const en = {
  characterCount: 'Characters',
  aboutLimitExceeded: 'Shorten your description to 190 characters before saving. Your text is still here.',
  aboutLineLimitExceeded: 'Keep your description to 4 lines before saving. Your text is still here.',
  aboutLineCount: 'Lines: {{count}} / {{limit}}',
  titleLimitExceeded: 'The event title can contain up to 1,200 characters. Your text is still here.',
  titleHTMLNotAllowed: 'Use plain text for the event title. Your text is still here.',
  commentLimitExceeded: 'A comment can contain up to 60,000 characters. Your full draft is still here.',
  commentMarkupLimitExceeded: 'There is too much formatting. Simplify it before sending. Your full draft is still here.',
  commentPhotoLimitExceeded: 'A comment can contain up to 10 photos. Remove extra photos before sending.',
};
const ru = {
  characterCount: 'Символы',
  aboutLimitExceeded: 'Сократите описание до 190 символов перед сохранением. Весь текст остался в редакторе.',
  aboutLineLimitExceeded: 'Сократите описание до 4 строк перед сохранением. Весь текст остался в редакторе.',
  aboutLineCount: 'Строки: {{count}} / {{limit}}',
  titleLimitExceeded: 'В названии события может быть до 1 200 символов. Весь текст остался в редакторе.',
  titleHTMLNotAllowed: 'Введите название события обычным текстом, без форматирования. Весь текст остался в редакторе.',
  commentLimitExceeded: 'В комментарии может быть до 60 000 символов. Полный черновик остался в редакторе.',
  commentMarkupLimitExceeded: 'Слишком много форматирования. Упростите его перед отправкой. Полный черновик остался в редакторе.',
  commentPhotoLimitExceeded: 'В комментарии может быть до 10 фотографий. Удалите лишние перед отправкой.',
};
const zh = {
  characterCount: '字符',
  aboutLimitExceeded: '请将简介缩短至 190 个字符后保存。完整文字仍保留在编辑器中。',
  aboutLineLimitExceeded: '请将简介缩减至 4 行后保存。完整文字仍保留在编辑器中。',
  aboutLineCount: '行数：{{count}} / {{limit}}',
  titleLimitExceeded: '事件标题最多包含 1,200 个字符。完整文字仍保留在编辑器中。',
  titleHTMLNotAllowed: '事件标题请使用纯文本。完整文字仍保留在编辑器中。',
  commentLimitExceeded: '评论最多包含 60,000 个字符。完整草稿仍保留在编辑器中。',
  commentMarkupLimitExceeded: '格式过多，请简化后再发送。完整草稿仍保留在编辑器中。',
  commentPhotoLimitExceeded: '一条评论最多包含 10 张照片。请删除多余照片后再发送。',
};
const translations = {
  en, ru, zh,
  es: {
    characterCount: 'Caracteres',
    aboutLimitExceeded: 'Acorta tu descripción a 190 caracteres antes de guardarla. Tu texto sigue en el editor.',
    aboutLineLimitExceeded: 'Reduce tu descripción a 4 líneas antes de guardarla. Tu texto sigue en el editor.',
    aboutLineCount: 'Líneas: {{count}} / {{limit}}',
    titleLimitExceeded: 'El título del evento puede contener hasta 1.200 caracteres. Tu texto sigue en el editor.',
    titleHTMLNotAllowed: 'Escribe el título del evento sin formato. Tu texto sigue en el editor.',
    commentLimitExceeded: 'Un comentario puede contener hasta 60.000 caracteres. Tu borrador completo sigue en el editor.',
    commentMarkupLimitExceeded: 'El comentario tiene demasiado formato. Simplifícalo antes de enviarlo. Tu borrador completo sigue en el editor.',
    commentPhotoLimitExceeded: 'Un comentario puede contener hasta 10 fotos. Elimina las fotos sobrantes antes de enviarlo.',
  },
  fr: {
    characterCount: 'Caractères',
    aboutLimitExceeded: 'Raccourcissez votre description à 190 caractères avant de l’enregistrer. Votre texte est toujours dans l’éditeur.',
    aboutLineLimitExceeded: 'Limitez votre description à 4 lignes avant de l’enregistrer. Votre texte est toujours dans l’éditeur.',
    aboutLineCount: 'Lignes : {{count}} / {{limit}}',
    titleLimitExceeded: 'Le titre de l’événement peut contenir jusqu’à 1 200 caractères. Votre texte est toujours dans l’éditeur.',
    titleHTMLNotAllowed: 'Saisissez le titre de l’événement sans mise en forme. Votre texte est toujours dans l’éditeur.',
    commentLimitExceeded: 'Un commentaire peut contenir jusqu’à 60 000 caractères. Votre brouillon complet est toujours dans l’éditeur.',
    commentMarkupLimitExceeded: 'Le commentaire contient trop de mise en forme. Simplifiez-la avant l’envoi. Votre brouillon complet est toujours dans l’éditeur.',
    commentPhotoLimitExceeded: 'Un commentaire peut contenir jusqu’à 10 photos. Supprimez les photos en trop avant l’envoi.',
  },
  de: {
    characterCount: 'Zeichen',
    aboutLimitExceeded: 'Kürze deine Beschreibung vor dem Speichern auf 190 Zeichen. Dein Text ist weiterhin im Editor.',
    aboutLineLimitExceeded: 'Kürze deine Beschreibung vor dem Speichern auf 4 Zeilen. Dein Text ist weiterhin im Editor.',
    aboutLineCount: 'Zeilen: {{count}} / {{limit}}',
    titleLimitExceeded: 'Der Titel des Ereignisses darf bis zu 1.200 Zeichen enthalten. Dein Text ist weiterhin im Editor.',
    titleHTMLNotAllowed: 'Gib den Titel des Ereignisses ohne Formatierung ein. Dein Text ist weiterhin im Editor.',
    commentLimitExceeded: 'Ein Kommentar darf bis zu 60.000 Zeichen enthalten. Dein vollständiger Entwurf ist weiterhin im Editor.',
    commentMarkupLimitExceeded: 'Der Kommentar enthält zu viele Formatierungen. Vereinfache sie vor dem Senden. Dein vollständiger Entwurf ist weiterhin im Editor.',
    commentPhotoLimitExceeded: 'Ein Kommentar darf bis zu 10 Fotos enthalten. Entferne überzählige Fotos vor dem Senden.',
  },
  it: {
    characterCount: 'Caratteri',
    aboutLimitExceeded: 'Riduci la descrizione a 190 caratteri prima di salvarla. Il testo è ancora nell’editor.',
    aboutLineLimitExceeded: 'Riduci la descrizione a 4 righe prima di salvarla. Il testo è ancora nell’editor.',
    aboutLineCount: 'Righe: {{count}} / {{limit}}',
    titleLimitExceeded: 'Il titolo dell’evento può contenere fino a 1.200 caratteri. Il testo è ancora nell’editor.',
    titleHTMLNotAllowed: 'Scrivi il titolo dell’evento senza formattazione. Il testo è ancora nell’editor.',
    commentLimitExceeded: 'Un commento può contenere fino a 60.000 caratteri. La bozza completa è ancora nell’editor.',
    commentMarkupLimitExceeded: 'Il commento contiene troppa formattazione. Semplificala prima dell’invio. La bozza completa è ancora nell’editor.',
    commentPhotoLimitExceeded: 'Un commento può contenere fino a 10 foto. Rimuovi le foto in eccesso prima dell’invio.',
  },
  pt: {
    characterCount: 'Caracteres',
    aboutLimitExceeded: 'Reduza sua descrição para 190 caracteres antes de salvar. Seu texto continua no editor.',
    aboutLineLimitExceeded: 'Reduza sua descrição para 4 linhas antes de salvar. Seu texto continua no editor.',
    aboutLineCount: 'Linhas: {{count}} / {{limit}}',
    titleLimitExceeded: 'O título do evento pode conter até 1.200 caracteres. Seu texto continua no editor.',
    titleHTMLNotAllowed: 'Escreva o título do evento sem formatação. Seu texto continua no editor.',
    commentLimitExceeded: 'Um comentário pode conter até 60.000 caracteres. Seu rascunho completo continua no editor.',
    commentMarkupLimitExceeded: 'O comentário tem formatação demais. Simplifique a formatação antes de enviar. Seu rascunho completo continua no editor.',
    commentPhotoLimitExceeded: 'Um comentário pode conter até 10 fotos. Remova as fotos excedentes antes de enviar.',
  },
  tr: {
    characterCount: 'Karakter',
    aboutLimitExceeded: 'Kaydetmeden önce açıklamanızı 190 karaktere kısaltın. Metniniz hâlâ düzenleyicide.',
    aboutLineLimitExceeded: 'Kaydetmeden önce açıklamanızı 4 satıra indirin. Metniniz hâlâ düzenleyicide.',
    aboutLineCount: 'Satır: {{count}} / {{limit}}',
    titleLimitExceeded: 'Etkinlik başlığı en fazla 1.200 karakter içerebilir. Metniniz hâlâ düzenleyicide.',
    titleHTMLNotAllowed: 'Etkinlik başlığını biçimlendirme kullanmadan yazın. Metniniz hâlâ düzenleyicide.',
    commentLimitExceeded: 'Bir yorum en fazla 60.000 karakter içerebilir. Taslağınızın tamamı hâlâ düzenleyicide.',
    commentMarkupLimitExceeded: 'Yorumda çok fazla biçimlendirme var. Göndermeden önce biçimlendirmeyi sadeleştirin. Taslağınızın tamamı hâlâ düzenleyicide.',
    commentPhotoLimitExceeded: 'Bir yorum en fazla 10 fotoğraf içerebilir. Göndermeden önce fazla fotoğrafları kaldırın.',
  },
  ja: {
    characterCount: '文字数',
    aboutLimitExceeded: '自己紹介を190文字以内にしてから保存してください。入力した文章はエディターに残っています。',
    aboutLineLimitExceeded: '自己紹介を4行以内にしてから保存してください。入力した文章はエディターに残っています。',
    aboutLineCount: '行数：{{count}} / {{limit}}',
    titleLimitExceeded: 'イベントのタイトルは1,200文字まで入力できます。入力した文章はエディターに残っています。',
    titleHTMLNotAllowed: 'イベントのタイトルは書式を付けずに入力してください。入力した文章はエディターに残っています。',
    commentLimitExceeded: 'コメントは60,000文字まで入力できます。下書きの全文はエディターに残っています。',
    commentMarkupLimitExceeded: '書式設定が多すぎます。書式を減らしてから送信してください。下書きの全文はエディターに残っています。',
    commentPhotoLimitExceeded: '1件のコメントに追加できる写真は10枚までです。余分な写真を削除してから送信してください。',
  },
  ko: {
    characterCount: '글자 수',
    aboutLimitExceeded: '소개를 190자 이내로 줄인 뒤 저장해 주세요. 작성한 글은 편집기에 그대로 남아 있습니다.',
    aboutLineLimitExceeded: '소개를 4줄 이내로 줄인 뒤 저장해 주세요. 작성한 글은 편집기에 그대로 남아 있습니다.',
    aboutLineCount: '줄 수: {{count}} / {{limit}}',
    titleLimitExceeded: '이벤트 제목은 최대 1,200자까지 입력할 수 있습니다. 작성한 글은 편집기에 그대로 남아 있습니다.',
    titleHTMLNotAllowed: '이벤트 제목은 서식 없이 일반 텍스트로 입력해 주세요. 작성한 글은 편집기에 그대로 남아 있습니다.',
    commentLimitExceeded: '댓글은 최대 60,000자까지 입력할 수 있습니다. 초안 전체는 편집기에 그대로 남아 있습니다.',
    commentMarkupLimitExceeded: '댓글에 서식이 너무 많이 적용되어 있습니다. 서식을 줄인 뒤 보내 주세요. 초안 전체는 편집기에 그대로 남아 있습니다.',
    commentPhotoLimitExceeded: '댓글 하나에 사진을 최대 10장까지 추가할 수 있습니다. 초과한 사진을 삭제한 뒤 보내 주세요.',
  },
  hi: {
    characterCount: 'अक्षर',
    aboutLimitExceeded: 'सहेजने से पहले अपना परिचय 190 अक्षरों तक छोटा करें। आपका लिखा हुआ टेक्स्ट अभी भी एडिटर में है।',
    aboutLineLimitExceeded: 'सहेजने से पहले अपना परिचय 4 पंक्तियों तक छोटा करें। आपका लिखा हुआ टेक्स्ट अभी भी एडिटर में है।',
    aboutLineCount: 'पंक्तियाँ: {{count}} / {{limit}}',
    titleLimitExceeded: 'इवेंट के शीर्षक में अधिकतम 1,200 अक्षर हो सकते हैं। आपका लिखा हुआ टेक्स्ट अभी भी एडिटर में है।',
    titleHTMLNotAllowed: 'इवेंट का शीर्षक बिना फ़ॉर्मैटिंग के लिखें। आपका लिखा हुआ टेक्स्ट अभी भी एडिटर में है।',
    commentLimitExceeded: 'एक टिप्पणी में अधिकतम 60,000 अक्षर हो सकते हैं। आपका पूरा ड्राफ़्ट अभी भी एडिटर में है।',
    commentMarkupLimitExceeded: 'टिप्पणी में बहुत ज़्यादा फ़ॉर्मैटिंग है। भेजने से पहले इसे कम करें। आपका पूरा ड्राफ़्ट अभी भी एडिटर में है।',
    commentPhotoLimitExceeded: 'एक टिप्पणी में अधिकतम 10 फ़ोटो हो सकती हैं। भेजने से पहले अतिरिक्त फ़ोटो हटा दें।',
  },
};
export default translations;
